import { InputAdornment } from '@material-ui/core';

export const getRenderCurrencyPrefixProps = (prefix: string) => ({
  classes: {
    input: '!pl-0 text-[14px] font-normal !h-[38px]',
  },
  startAdornment: (
    <InputAdornment position="start" className="mr-0.5">
      <span className="text-[14px] text-black-heading">{prefix}</span>
    </InputAdornment>
  ),
});
